import { faLink, faMapLocationDot, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import type { NavigateFunction } from "react-router-dom";
import type { IPagedListAction } from "../../components/UI/Declarations";
import {
    buildCustomerAdminPagedListActions,
    type CustomerAdminConfirmKind,
} from "../CustomersListPage/customerAdminListActions";

export type CustomerEditActiveView = "edit" | "locations" | "newLocation";

export function buildCustomerEditHeaderActions(
    navigate: NavigateFunction,
    customerId: string,
    openConfirm: (kind: CustomerAdminConfirmKind) => void,
    activeView: CustomerEditActiveView
): IPagedListAction[] {
    const navigationAction: IPagedListAction =
        activeView === "edit"
            ? {
                  text: "View Locations",
                  icon: faMapLocationDot,
                  onClick: () => navigate(`/customers/${customerId}/locations`),
              }
            : activeView === "locations"
              ? {
                    text: "Edit Customer",
                    icon: faPenToSquare,
                    onClick: () => navigate(`/customers/${customerId}`),
                }
              : {
                    text: "Back to Locations",
                    icon: faLink,
                    onClick: () => navigate(`/customers/${customerId}/locations`),
                };

    const lifecycleActions = buildCustomerAdminPagedListActions(openConfirm);
    if (lifecycleActions.length > 0) {
        lifecycleActions[0] = { ...lifecycleActions[0], startGroup: true };
    }

    return [navigationAction, ...lifecycleActions];
}

export function customerEditHeaderNavLabel(activeView: CustomerEditActiveView): string {
    switch (activeView) {
        case "edit":
            return "View Locations";
        case "locations":
            return "Edit Customer";
        case "newLocation":
            return "Back to Locations";
    }
}

export function customerEditHeaderNavPath(activeView: CustomerEditActiveView, customerId: string): string {
    switch (activeView) {
        case "edit":
            return `/customers/${customerId}/locations`;
        case "locations":
            return `/customers/${customerId}`;
        case "newLocation":
            return `/customers/${customerId}/locations`;
    }
}
